import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Toast,
  Divider,
  Selector,
  Space
} from "antd-mobile";
import "./index.css";
import { useNavigate, useLocation } from "react-router-dom";
import {
  parseQueryString,
  opt_ar_busType,
  opt_ar_companyType,
} from "../interface";
import axios from "axios";
import { domain } from "../interface";
// import * as _ from "lodash";

let selectProducts = {};
let endDates = {};
let businessName = {};
let versionNames = {};
const AccountRegister = () => {

  let navigate = useNavigate();
  let location = useLocation();

  const [pathUrl, setPathUrl] = useState(
    parseQueryString(window.location.href)
  );

  const [form] = Form.useForm();
  const [productVersion, setProductVersion] = useState([]);
  const [customerCode, setCustomerCode] = useState("");
  const [products, setProducts] = useState([]);
  const [busType, setBusType] = useState("10");
  const [customerName, setcustomerName] = useState("");
  const [customerType, setCustomerType] = useState("1");
  
  const [registerCode, setRegisterCode] = useState("");
  const [adminName, setAdminName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminMobile, setAdminMobile] = useState("");
  const [creditCode, setCreditCode] = useState("");
  
  const [isDisabled, setIsDisabled] = useState(false);


  const getProductVersionList = () => {
    axios
      .post(domain + "/account/get_product_version")
      .then((res) => {
        console.log(res)
        if (res.status == 200 && res.data) {
          let resData = res.data;
          if (resData.code == 200 && resData.data) {
            console.log("resData")
            console.log(resData)
            setProductVersion(resData.data.productList)
          } else {
            // setData([]);
            Toast.show({
              content: "获取产品版本列表错误！",
            });
          }
        } else {
          setProductVersion({});
        }
      })
      .catch((error) => {
        console.error("corpId err, " + JSON.stringify(error));
      });
  };

  const onBusTypeChange = (e) => {
    // setBusType(e.target.value);
    // form.setFieldsValue({
    //   module: e.target.value,
    // });
  };

  const onFinish = (values) => {
    let params = {
      ...values,
      "products":selectProducts,
      "endDates":endDates,
      "businessName":businessName,
      "versionNames":versionNames
    };

    console.log(params)
    let userId = localStorage.getItem("userId");
    let userName = localStorage.getItem("userName");
    if (userName == null || userName == "") {
      userName = "邢汝华";
    }

    if (userId == null || userId == "") {
      userId = "ruhua";
    }
    // setIsDisabled(true);
    axios
      .post(domain + "/account/accountRegister", {
        ...params,
        userId: userId,
        userName: userName,
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200 && res.data) {
          if (res.data.code === "200") {
            Toast.show({
              content: "保存成功",
            });
            //清空数字
            // fileListObj.splice(0, fileListObj.length);
            navigate("/home");
          } else {
            Toast.show({
              content: res.data.message,
            });
          }
        } else {
          Toast.show({
            content: "操作失败:"+res.data.message,
          });
          // setIsDisabled(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const  state  = location.state;
    if (productVersion.length<=0){
      getProductVersionList();
    }  
    if (state != null && state.hasStorage === "1") {
      //如果是查看详情跳转用跳转的id调用详情接口
      //否则是选择客户跳转
      const values = form.getFieldsValue();
      let objForm = {};
      for (let k in values) {
        objForm[k] =state[k]
      }
      setAdminName(state.adminName)
      setAdminEmail(state.adminEmail)
      setAdminMobile(state.adminMobile)
      setCustomerType(state.customerType)
      setRegisterCode(state.registerCode)
      setCustomerCode(state.customerCode)
      setcustomerName(state.customerName)
      setCreditCode(state.creditCode)
      setBusType(
        localStorage.getItem("busType") != "undefined" &&
          localStorage.getItem("busType") != "null"
          ? localStorage.getItem("busType")
          : "10"
      );

      objForm["busType"]=localStorage.getItem("busType")

      versionNames={}
      endDates={}
      businessName={}
      selectProducts={}
      // console.log("busType")
      // console.log(busType)
      form.setFieldsValue({ ...objForm });
    } else {
      //新增表单
      // form.setFieldsValue({ module: "option-1676103442876" });
    }
  }, [pathUrl]);

  //跳转到选择客户页面
  const goCustomer = () => {
    const values = form.getFieldsValue();
    for (let k in values) {
      localStorage.setItem(k, values[k]);
    }
    localStorage.setItem("customerCode", customerCode);
    localStorage.setItem("busType", busType);
    localStorage.setItem("navigate", "accountRegister");


    navigate("/customer");
  };


  return (
    <div className="page distributePage">
      {/* <NavBar onBack={back}>表单编辑</NavBar> */}
      <Form
        requiredMarkStyle='asterisk'
        onFinish={onFinish}
        form={form}
        initialValues={{
          busType: "1",
        }}
        footer={
          !pathUrl.id && (
            <Button
              disabled={isDisabled}
              block
              type="submit"
              color="primary"
              size="large"
            >
              提交
            </Button>
          )
        }
      >
      <Form.Item
          name="busType"
          label="选择业务"
          hidden="True"
          rules={[{ required: true, message: "选择业务" }]}
        >
          <select
            className="editSelect"
            disabled={pathUrl.id}
            onChange={onBusTypeChange}
          >
            {opt_ar_busType.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </Form.Item>

        <Form.Item
          className="customeNameBox"
          name="customerName"
          label="公司全称"
          rules={[{ required: true, message: "公司全称不能为空" }]}
        >
          <Input
            placeholder="选择公司全称"
            value={customerName}
            disabled
            autoComplete="off"
          />
            <Button
              onClick={() => {
                goCustomer();
              }}
              className="editCustomer"
              block
              color="primary"
              size="small"
            >
              选择公司
            </Button>
          
        </Form.Item>

        <Form.Item
          className="btnselect"
          name="customerType"
          rules={[{ required: true, message: "公司类型不能为空" }]}          
          label="公司类型"
        >
          <select
            className="editSelect"
            defaultValue={"1"}
            disabled
            >
            {opt_ar_companyType.map((item) => (
              <option key={item.value} value={item.value} >
                {item.label}
              </option>
            ))}
          </select>
        </Form.Item>

        <Form.Item
          
          className="btnselect"
          name="customerCode"
          label="公司代码"
          rules={[{ required: true, message: "公司代码不能为空" }]}
        >
          <Input
            placeholder=""
            value={customerCode}
            disabled
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item
          className="btnselect"
          name="registerCode"
          label="协会代码"
          
          rules={[{ required: true, message: "协会代码不能为空" }]}
        >
          <Input
            placeholder=""
            value={registerCode}
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item
          name="adminName"
          label="管理员名称"
          
          mode='card'
          rules={[{ required: true, message: "管理员名称不能为空" }]}
        >
          <Input
            placeholder=""
            value={adminName}
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item
          className="btnselect"
          name="adminEmail"
          label="管理员邮箱"
          

          rules={[{ required: true, message: "管理员邮箱不能为空" }]}
        >
          <Input
            type="email" 
            placeholder=""
            value={adminEmail}            
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item
          className="btnselect"
          name="adminMobile"
          label="管理员手机号"
          

          rules={[{ required: true, message: '请输入正确的手机号'}]}
          >
          <Input
            placeholder=""
            value={adminMobile}
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item
          className="btnselect"
          name="creditCode"
          label="统一社会信用代码"
          rules={[{ required: true, message: "统一社会信用代码 不能为空" }]}

          >
          <Input
            placeholder=""
            value={creditCode}
            autoComplete="off"
          />
        </Form.Item>        
        <Divider>相关产品</Divider>
        
        {productVersion.map(item =>( 
            <Form.Item
              className="btnselect"
              hidden={busType!=="10"}
              label={item.businessName}
            >
                <Selector
                      options={item.verList.filter(item => item.sellableState !== 0)}
                      showCheckMark={false}
                      columns={2}
                      style={{
                        '--border-radius': '100px',
                        '--border': 'solid transparent 1px',
                        '--checked-border': 'solid var(--adm-color-primary) 1px',
                        '--padding': '8px 24px',
                      }}                      
                      onChange={(arr, extend) => {
                        selectProducts["E_"+item.businessCode]=arr;
                        if(extend.items.length>0){
                          versionNames["E_"+item.businessCode]=extend.items[0].label;
                          endDates["E_"+item.businessCode]=item.endDate;
                          businessName["E_"+item.businessCode]=item.businessName;
                        }else{
                          versionNames["E_"+item.businessCode]="";
                          endDates["E_"+item.businessCode]="";
                          businessName["E_"+item.businessCode]="";
                        }
                      }}
                />
            </Form.Item>  
        
        ))
        }   

      </Form>
    </div>
  );
};
export default AccountRegister;
